import { mutation_updateFascicolo,mutation_postFascicolo,mutation_deleteFascicolo } from "../mutations/fascicoloMutations";
import { useMutation,useQuery } from "@1f/react-sdk";
import { query_getFascicoliAndRelatedEntities, query_getFascicoloById } from "../query/fascicoloQueris";
import sharedDatasInstance from "../sharedDatas";
import { apiErrorHelper } from "../helpers/apiErrorHelpers";
import { DateHelpers } from "../helpers/dateHelpers";
import { query_rischio_fascicoli_anagrafiche_stats } from "../query/statsQueries";
import { removeLocalStorageSelectedFascicolo } from "../helpers/storageHelpers";

export const FascicoloApi = () => {
    let loggedUserId = sharedDatasInstance.getPropertyByName("userId");
    let aziendaId = sharedDatasInstance.getPropertyByName("aziendaId");
    const errorApiHelpers = apiErrorHelper();
    const dateHelpers = DateHelpers();
    const apiCreateFascicolo = useMutation(mutation_postFascicolo, {
        graphqlEndpoint: "aml:hasura:api://v1/graphql",
    });
    const apiUpdateFascicolo = useMutation(mutation_updateFascicolo, {
        graphqlEndpoint: "aml:hasura:api://v1/graphql",
    });
    const apiDeleteFascicolo = useMutation(mutation_deleteFascicolo, {
        graphqlEndpoint: "aml:hasura:api://v1/graphql",
    });
    const apiFascicoloById = useQuery(
        query_getFascicoloById,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiGetFascicoliAndRelatedEntities = useQuery(
        query_getFascicoliAndRelatedEntities,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    )
    const apiRischioFascicoliAnagraficheStats = useQuery(
        query_rischio_fascicoli_anagrafiche_stats,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );

    const GetFascicoloById = async (fascicoloId) => {
        try {
            const fascicoloResponse = await apiFascicoloById.fetch({
                fascicoloId: fascicoloId,
            })       
            if(fascicoloResponse && fascicoloResponse.data) {
                return fascicoloResponse.data.data.getFascicoloById;
            }
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Impossibile recuperare il fascicolo");
        }
    }
    const CreateFascicolo = async (tenantId,fascicolo) => {
        try {
            let toCreateFascicolo = {
                id : fascicolo.id,
                tenantId : fascicolo.tenantId,
                name : fascicolo.name,
                date : dateHelpers.FormatToUTCWithoutTimezone(fascicolo.date,false),
                isPrivate : fascicolo.isPrivate,
                createdOn : dateHelpers.FormatToUTCWithoutTimezone(fascicolo.createdOn,false),
                createdBy : fascicolo.createdBy,
                modifiedOn : dateHelpers.FormatToUTCWithoutTimezone(fascicolo.modifiedOn,false),
                aziendaId: fascicolo.aziendaId,
                modifiedBy : fascicolo.modifiedBy
            }
            let postResponse = await apiCreateFascicolo.fetch({
                tenantId: tenantId,
                aziendaId: aziendaId,
                dataInput: toCreateFascicolo
            });
            if(postResponse && postResponse.data){
                return postResponse.data.data.postFascicolo;
            }    
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Impossibile creare il fascicolo");
        }
    }        
    const UpdateFascicolo = async (fascicolo,isPrivate) => {
        try {
            let toupdateFascicolo = {
                id : fascicolo.id,
                tenantId: fascicolo.tenantId,
                name: fascicolo.name,
                date: fascicolo.date,
                isPrivate: isPrivate,
                createdOn: fascicolo.createdOn,
                createdBy : fascicolo.createdBy,
                modifiedOn: fascicolo.modifiedOn,
                aziendaId: fascicolo.aziendaId,                
                modifiedBy: loggedUserId
            }

            let updateResponse = await apiUpdateFascicolo.fetch({
                id: fascicolo.id,
                userId : loggedUserId,
                aziendaId: aziendaId,
                dataInput: toupdateFascicolo
            });
            if(updateResponse){
                return true
            }
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Impossibile aggiornare il fascicolo");
        }
    }
    const DeleteFascicolo = async (fascicoloId) => {
        try {
            let deleteResponse =  await apiDeleteFascicolo.fetch({
                id: fascicoloId,                
                aziendaId: aziendaId
            });
            if(deleteResponse && deleteResponse.data){
                const success = deleteResponse.data.data.deleteFascicolo.success;
                if (success) {
                    removeLocalStorageSelectedFascicolo(fascicoloId);
                }
                return success;
            }
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Impossibile eliminare il fascicolo");
        }
    }
    const GetFascicoliAndRelatedEntities = async (tenantId,includePrivate,includeTerminated,fascicoloId) => {
        const currentAziendaId = sharedDatasInstance.getPropertyByName("aziendaId");
        try {
            const fascResponse = await apiGetFascicoliAndRelatedEntities.fetch({
                tenantId: tenantId,
                aziendaId: currentAziendaId,
                includePrivate: includePrivate,
                includeTerminated: includeTerminated,
                onlyId : fascicoloId
            });
            
            if(fascResponse && fascResponse.data) {
                return fascResponse.data.data.getFascicoliAndRelatedEntities;
            }
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            const apiError = new Error(errorMessage || "Impossibile recuperare i fascicoli e le entità correlate");
            const notFoundMessage = `Fascicolo ${fascicoloId} not found in azienda ${currentAziendaId}`;
            if (Number.isInteger(fascicoloId) && fascicoloId > 0 &&
                (error?.message === notFoundMessage || error?.message === `${notFoundMessage}.`)) {
                apiError.code = "FASCICOLO_NOT_FOUND";
            }
            throw apiError;
        }
    }

    return {
        GetFascicoloById,
        GetFascicoliAndRelatedEntities,
        CreateFascicolo,
        UpdateFascicolo,
        DeleteFascicolo
    }
}